<script lang="ts">
import { createEventDispatcher } from 'svelte';

    import {
      Button,
      Modal,
      ModalBody
    } from 'sveltestrap';

    export let open: boolean;
    const dispach = createEventDispatcher()

  </script>

  <style lang="scss">

    .modal-close-parking{
      color: #0E3CA5;



    }

    :global(#button-modal-close){
        width: 85%;
        margin: auto;
        display: block;
        background-color: #34A853;
        border-color: #34A853;
        min-height: 45px;
        font-size: 20px;
        font-weight: bold;
        border-radius: 10px;
        color: #fff;
      }

      .h1-modal{
        font-weight: bold;
        font-size: 20px;
        color: #0E3CA5;
      }

      .p-modal{
        color: #0E3CA5;
      }

  </style>
  
  {#if open}
    <div class="modal-close-parking">  
        <Modal isOpen={open} backdrop="static" class="modal-dialog modal-dialog-centered">
          <ModalBody class="text-center">
              <h1 class="h1-modal">BUENAVISTA ZONA AZUL</h1> 
              <p class="p-modal">Muchas gracias por utilizar el aparcamiento</p> 
              <Button id="button-modal-close" color="primary" on:click={() => {
                dispach('parkingSolved')
              } }>Inicio</Button>
          </ModalBody>
        </Modal>
    </div>
  {/if}
